<template>
	
	<!-- 工资导入 -->
	<Modal :value="value" title="员工考勤明细导入" @on-cancel = "cancel">
		<Form ref="slalryForm"  :label-width="80" :rules="rule" :model="salary">
			<FormItem label='文件'  prop="guid">
				<Upload :action="action" ref="uploadSalary"
						:on-success="fileSuccess"
						:before-upload="flieUpload"
						:on-error="fileError">
					<Button icon="ios-cloud-upload-outline">选择文件</Button>
				</Upload>
			</FormItem>
		</Form>
		<div slot="footer">
			<Button type="primary" @click="test" :loading='BtnDisabled'>检测</Button>&nbsp;
			<Button type="primary" @click="importSalary" :disabled='BtnDisabledOK'>导入</Button>&nbsp;
		</div>
	</Modal>
	
</template>

<script>
	export default {
		props:{
			value:false,
		},
		data () {
			return {
				BtnDisabledOK:true,
				BtnDisabled:false,
				action:abp.url+'/file/Upload',
				salary:{
					guid:""
				},
				rule:{
					guid:[{required: true,message:'必填项不能为空',trigger: 'change'}]
				},
			}
		},
		mounted() {
			
		},
		methods:{
			
			//清除验证
			clearn(){
				this.$refs.uploadSalary.clearFiles();
				this.$refs.slalryForm.resetFields();
			},
			//假期分配
			importSalary(){
				this.$refs.slalryForm.validate(async(valid)=>{
				    if(valid){
            let reponse = await this.$Ajax.get('api/services/app/AttendanceRecord/GetSaveExcelData',{params:this.salary});
						if(reponse.data.result.success){
							this.$Message.success("导入成功");
						    this.$emit('close')
						}else{
              this.$Modal.confirm({
                title: "提示",
                content: reponse.data.result.errorMsg,
                okText: "确认",
                // onOk: () => {
                // },
              });
            }
				    }
				})
			},
			//检测
			test(){
				this.$refs.slalryForm.validate(async (valid)=>{
        //   console.log(this.salary)
				    if(valid){
            let reponse = await this.$Ajax.get('api/services/app/AttendanceRecord/GetCheckExcelData',{params: this.salary});
            // console.log(reponse)
						if(reponse.data.result.success){
							this.$Message.success("检测成功");
							this.BtnDisabledOK = false;
						}else{
							let html=``;
							for(let i=0; i<reponse.data.result.errorMsg.length; i++){
								html += `${reponse.data.result.errorMsg[i]}<br/>`
							}
							this.$Modal.warning({
								title: '错误',
								content:`<div style="color:#f00;max-height:400px;overflow:auto">${html}</div>` 
							});
						}
				    }
				})
			},
			cancel(){
				this.$emit('close')
			},
			//文件上传之前
			flieUpload() {
				this.BtnDisabledOK = true;
				if(this.salary.guid){
					this.$refs.uploadSalary.clearFiles();
					this.BtnDisabled = true;
				}
			},
			//文件上传成功
			fileSuccess(response, file, fileList) {
			    this.salary.guid = response.result.guid;
			    let flog = fileList.filter((el) => {
			        if (el.status == "uploading") {
			            return el;
			        }
			    });
			    if (flog.length <= 0) {
			        this.BtnDisabled = false;
			    }
			},
			//文件上传失败
			fileError(error, file, fileList) {
				let flog = fileList.filter((el) => {
					if (el.status == "uploading") {
						return el;
					}
				});
				if (flog.length <= 0) {
					this.BtnDisabled = false;
				}
			},
		}
	}
</script>

<style>
</style>
